export default {
  'isShowMapa': true,
  'isShowTrainingCheckinRecord': true,
  'isShowESign': true,
  'isShowAttendance': true,
  'isShowOT': true,
  'isShowEncrypted': true,
  'isShowAppBar': false,
  'isShowAttendanceOutSource': true,
  'isShowPushMsgSetting': true,
  'isSupportAutoEdocDeliver': true,
  'isEncryptDynamicFlow': true,
  'apiDomain': {
    'ALI': 'https://api-uat.g2e.informac.gov.mo',
    'LC': 'https://bapi-uat.g2e.informac.gov.mo',
    'INT': 'https://api-uat.g2e.informac.gov.mo',
    'BOARDWARE_WORKFLOW': 'https://www-uat.g2e.informac.gov.mo/ext/ot/'
  },
  'isUAT': true,
  'isProd': false,
  'domain': 'https://www-uat.g2e.informac.gov.mo/'
}
